import React from 'react';
import Serviceimg from '../../assets/images/about_service_2.webp';
import { Link } from 'react-router-dom';
import { siteCopy } from '../../content/siteCopy';

const Service = () => {
  const { mission } = siteCopy.aboutUs;

  return (
    <>
      <section className="row_am service_section about_service">
        <div className="container">
          <div className="row service_blocks flex-row-reverse">
            <div className="col-md-6">
              <div
                className="service_text right_side"
                data-aos="fade-up"
                data-aos-duration={1500}
              >
                <div className="title_badge">
                  <span>{mission.badge}</span>
                </div>
                <h2>{mission.title}</h2>
                <p>{mission.body}</p>
                <ul className="feature_list">
                  {mission.bullets.map((item) => (
                    <li key={item}>
                      <div className="icon">
                        <span>
                          <i className="icofont-check-circled" />
                        </span>
                      </div>
                      <div className="text">
                        <p>{item}</p>
                      </div>
                    </li>
                  ))}
                </ul>
                <div className="btn_block">
                  <Link to={mission.ctaTo} className="btn puprple_btn ml-0">
                    {mission.ctaLabel}
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div
                className="inner_block rotate_right"
                data-aos="fade-up"
                data-aos-duration={1500}
              >
                <div className="img">
                  <img src={Serviceimg} alt="Noor app: Toolbox tools and habits" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Service;
